/* ============================================================
   mega-menu.js  →  assets/mega-menu.js
   ============================================================ */
(function () {
  'use strict';

  var CLOSE_DELAY = 130;
  var overlay, closeTimer;

  function init() {
    overlay = document.createElement('div');
    overlay.className = 'mega-menu-overlay';
    document.body.appendChild(overlay);

    document.querySelectorAll('.mega-menu__item').forEach(function (item) {
      var dropdown = item.querySelector('[data-mega-menu]');
      if (!dropdown) return;

      // ==========================
      // Desktop Hover
      // ==========================
      item.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;

        clearTimeout(closeTimer);
        closeAll();
        openItem(item);
      });

      item.addEventListener('mouseleave', function () {
        if (window.innerWidth < 990) return;

        closeTimer = setTimeout(function () {
          closeItem(item);
        }, CLOSE_DELAY);
      });

      dropdown.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;
        clearTimeout(closeTimer);
      });

      dropdown.addEventListener('mouseleave', function () {
        if (window.innerWidth < 990) return;

        closeTimer = setTimeout(function () {
          closeItem(item);
        }, CLOSE_DELAY);
      });

      // ==========================
      // Click
      // ==========================
      var trigger = item.querySelector('.mega-menu__trigger');

      if (trigger) {
        trigger.addEventListener('click', function (e) {

          // MOBILE
          // Keep existing mobile functionality.
          if (window.innerWidth < 990) {
            return;
          }

          // DESKTOP
          // Do NOT prevent default.
          // Hover opens dropdown.
          // Click follows the link normally.
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (window.innerWidth < 990) return;

      if (!e.target.closest('.mega-menu__item')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
      }
    });
  }

  function openItem(item) {
    item.classList.add('is-open');
    overlay.classList.add('is-visible');

    var trigger = item.querySelector('.mega-menu__trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeItem(item) {
    item.classList.remove('is-open');

    var trigger = item.querySelector('.mega-menu__trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (!document.querySelector('.mega-menu__item.is-open')) {
      overlay.classList.remove('is-visible');
    }
  }

  function closeAll() {
    document.querySelectorAll('.mega-menu__item.is-open').forEach(closeItem);

    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();